import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import {
  Card,
  Dimmer,
} from 'semantic-ui-react';

const Container = styled(Dimmer)`
  &&& {
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const Dialog = styled(Card)`
  &&& {
    padding: 25px;
    width: 600px;
    height: 100%;
    border: 1px solid #caced4;
    border-radius: 8px;
    align-items: start;
  }
`;

const Title = styled(TextLayoutComponent.Header)`
  color: #192c47;
  font-size: 18px;
  font-weight: 500;
`;

const Text = styled(TextLayoutComponent)`
  font-size: 16px;
`;

const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 15px;
  border: 1px solid #caced4;
  border-radius: 8px;
  margin: 10px 0;
  padding-bottom: ${(props) => (props.isError ? '0' : '20px')};
`;

const getColor = (props) => {
  if (props.isError) {
    return '#ff1744';
  }
  if (props.isDragging) {
    return '#2196f3';
  }
  return '#caced4';
};

const UploadBox = styled.div`
  border-width: 2px;
  border-style: dashed;
  border-color: ${(props) => getColor(props)};
  background-color: ${(props) => (props.isError ? 'rgb(255, 0, 0, 0.2)' : 'transparent')};
  padding: 40px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  cursor: pointer;

  &:hover,
  &:focus {
    border-color: #2196f3;
  }
`;

const InputFile = styled.input`
  display: none;
`;

const Link = styled.a`
  color: #477ae9;
  text-decoration: none;
`;

const AcceptedFilesText = styled(TextLayoutComponent)`
  font-style: italic;
  font-size: 14px;
`;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  align-self: self-end;
  text-align: right;
  padding: 5px;
`;

const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  padding: 5px 0;
`;

export {
  AcceptedFilesText,
  Container,
  ContainerBox,
  Dialog,
  ErrorMessage,
  InputFile,
  Link,
  ProgressContainer,
  Text,
  Title,
  UploadBox,
};
